import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import notifierReducer from './notifierReducer';
import mapReducer from '../components/Map/reducers/MapReducer';
import usersReducer from '../views/Management/reducers/UsersReducer';
import operatorsReducer from '../views/Management/reducers/OperatorsReducer';
import settingsReducer from '../views/Management/reducers/SettingsReducer';
import dashboardInspectReducer from '../views/Dashboard/reducers/DashboardInspectReducer';
import siteTrackerReducer from '../views/SiteTracker/reducers/SiteTrackerReducer';
import reportsKpisReducer from '../views/ReportsKpisOps/reducers/ReportsKpisReducer';
import reportsKpisRanReducer from '../views/ReportsKpisRan/reducers/ReportsKpisRanReducer';
import reportsAcceptanceReducer from '../views/ReportsAcceptance/reducers/ReportsAcceptanceReducer';
import hostToolsReducer from '../views/HostTools/reducers/HostToolsReducer';
import scriptsGenerationReducer from '../views/ScriptsGeneration/reducers/ScriptsGenerationReducer';
import bridgeCallReducer from '../views/BridgeCall/reducers/BridgeCallReducer';

const rootReducer = combineReducers({
	session: sessionReducer,
	usersReducer,
	notifierReducer,
	operatorsReducer,
	settingsReducer,
	dashboardInspectReducer,
	mapReducer,
	siteTrackerReducer,
	reportsKpisReducer,
	reportsKpisRanReducer,
	reportsAcceptanceReducer,
	hostToolsReducer,
	scriptsGenerationReducer,
	bridgeCallReducer
});

export default rootReducer;
